import { Div, Link, Span } from "@tblabs/truffle";


export class AddFieldBox extends Div
{
    constructor(entries: Record<string, () => void>)
    {
        super("add-field-box")

        this.Append(
            new Span("Dodaj: ").MarginRight(8),
            ...Object.entries(entries)
                .map(([label, onClick]) =>
                    new Link(label).Style(`white-space: nowrap;`).OnClick(onClick)),
        )
    }
}
